if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const formInput = target.closest('.product-form__input');
          if (!formInput) return;
          if (formInput.classList.contains('bm-pdp-meta-picker--metal')) {
            const root = formInput.querySelector('[data-bm-metal-heading-root]');
            if (root) {
              const nameEl = root.querySelector('[data-bm-metal-heading-name]');
              const descEl = root.querySelector('[data-bm-metal-heading-desc]');
              const metaName = target.getAttribute('data-bm-metal-name') || value;
              const metaDesc = target.getAttribute('data-bm-metal-desc') || '';
              if (nameEl) nameEl.textContent = metaName;
              if (descEl) {
                descEl.textContent = metaDesc;
                if (metaDesc.trim()) {
                  descEl.removeAttribute('hidden');
                } else {
                  descEl.setAttribute('hidden', '');
                }
              }
            }
            return;
          }
          if (formInput.classList.contains('bm-pdp-carat-picker')) {
            const headingSpan = formInput.querySelector('[data-selected-swatch-value]');
            if (headingSpan) {
              const suffix = formInput.dataset.bmCaratHeadingSuffix || '';
              const raw = String(value || '').trim();
              const token = raw
                .replace(/,/g, '.')
                .split(/\s+/)
                .filter(Boolean)[0] || '';
              headingSpan.textContent =
                token && suffix ? `${token} ${suffix}`.trim() : raw || value;
            }
            return;
          }
          const selectedSwatchValue = formInput.querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
